export default {
  correspondant: {
    overview: 'Détail du correspondant',
    name: 'Correspondant',
    search: {
      nomContactEtablissement: 'Nom du correspondant',
      prenomContactEtablissement: 'Prénom du correspondant',
      idSearchEtablissement: "Identifiant de l'établissement",
      raisonSocialEtablissement: "Raison sociale de l'établissement",
      searchEntrepriseInsee: 'Uniquement entreprise / groupement',
    },
    list: {
      title: 'Liste des Correspondants',
      headers: {
        id: 'Identifiant',
        civilite: 'Civilité',
        name: 'Nom',
        mail: 'Mail',
        telfixe: 'Téléphone fixe',
        telPortable: 'Téléphone portable',
        etablissementRaisonSociale: "Raison sociale de l'établissement",
        entrepriseRaisonSociale: "Raison sociale de l'entreprise",
        groupementRaisonSociale: 'Raison sociale du groupement',
      },
      fetch: {
        error: 'Impossible de récupérer la liste des correspondants',
      },
    },
    details: {
      id: 'Identifiant',
      civilite: 'Civilité',
      nom: 'Nom',
      prenom: 'Prénom',
      telFixe: 'Téléphone fixe',
      telPortable: 'Téléphone portable',
      fax: 'Fax',
      mail: 'Mail',
      fonction: 'Fonction',
      etablissementId: "Identifiant de l'établissement",
      etablissementRaisonSociale: "Raison sociale de l'établissement",
      entrepriseInseeId: "Identifiant de l'entreprise",
      entrepriseInseeRaisonSociale: "Raison sociale de l'entreprise",
      groupementId: 'Identifiant du groupement',
      groupementRaisonSociale: 'Raison sociale du groupement',
      roleAdmin: 'Administration',
      roleFacturation: 'Facturation',
      roleEnvoiCourrier: 'Envoi du courrier',
      contact: 'Coordonnées du contact',
      etablissementRattachement: 'Établissement de rattachement',
      entrepriseInseeRattachement: 'Entreprise de rattachement',
      groupementRattachement: 'Groupement de rattachement',
      role: 'Rôles du correspondant',
      adresseGeographique: 'Adresse géographique',
      adresseFacturation: 'Adresse de facturation',
      utiliserAdresseGeographique: "Identique à l'adresse géographique",
    },
    fetch: {
      error: 'Impossible de récupérer le correspondant dans Essenciem',
      coordonnees: {
        error:
          'Impossible de récupérer les coordonnées du correspondant dans Essenciem',
      },
    },
    save: {
      error: 'Erreur technique à la sauvegarde du correspondant',
    },
    etablissement: {
      id: 'Identifiant',
      raisonSociale: 'Raison sociale',
      siret: 'SIRET',
    },
  },
}
